// extracted by mini-css-extract-plugin
module.exports = {"item":"InfoBlock_item__Kz_1o","label":"InfoBlock_label__1rJtP","itemText":"InfoBlock_itemText__2YjBB"};